import { makeAutoObservable } from 'mobx';

export type PaymentMethodJSON = {
  id: string;
  brand?: string | null;
  last4?: string | null;
  isDefault: boolean;
};

const byId = new Map<string, PaymentMethod>();

export class PaymentMethod {
  json: PaymentMethodJSON;

  private constructor(json: PaymentMethodJSON) {
    this.json = json;
    makeAutoObservable(this);
  }

  static fromJSON(json: PaymentMethodJSON) {
    let instance = byId.get(json.id);
    if (!instance) {
      instance = new PaymentMethod(json);
    } else {
      instance.updateFromJson(json);
    }
    byId.set(instance.id, instance);
    return instance;
  }

  get id() {
    return this.json.id;
  }

  get brand() {
    return this.json.brand;
  }

  get last4() {
    return this.json.last4;
  }

  get maskedLast4() {
    return this.json.last4 ? `•••• ${this.json.last4}` : '••••';
  }

  get isDefault() {
    return this.json.isDefault;
  }

  updateFromJson(json: Partial<PaymentMethodJSON>) {
    this.json = { ...this.json, ...json };
  }
}
